import core from '~/core/scripts';
import './index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!./index.html');

  if (location.pathname.includes('.html')) {
    const fileToLoad = location.pathname.replace('.html', '.js');
    try {
      require(`./layout-samples${fileToLoad}`);
    } catch(e) {
      console.log(e);
      console.log(`[Starterkit] no file found ${fileToLoad}`);
    }
  }
}
